export const SPACING_MAP = {
  // Source: https://github.com/NerdWallet/base-styles/blob/1b2ef4659b28e023c282cf0d5f8ffd38488bbc87/generated/variables.js#L129

  '0': undefined,
  '1': 1,
  '2': 2,
  '3': 3,
  '3-half': 3.5,
  '4': 4,
  '5': 5,
  '0--wide': undefined,
  '1--wide': { sm: 1 },
  '2--wide': { sm: 2 },
  '3--wide': { sm: 3 },
  '3-half--wide': { sm: 3.5 },
  '4--wide': { sm: 4 },
  '5--wide': { sm: 5 },
} as const;
